(function () {
    'use strict';

    /**
    * @memberof app
    * @ngdoc controller
    * @name Colaboracion
    * @description
    * This is main controller
    **/

    angular
        .module('app')
        .controller('Colaboracion', Colaboracion);

	Colaboracion.$inject = ['ColaboracionService', '$scope', '$window', '$http', '$filter', '$timeout', '$sce'];


    function Colaboracion(ColaboracionService, $scope, $window, $http, $filter, $timeout, $sce) {
		console.log("colaboracion");
        var vm = this;
        vm.pagina = 0;
        vm.ficheros = [];
        vm.respuestas = [];
        vm.colCompletadas = false;
        vm.botonChecked = [];
        vm.archivosubido = false;
        vm.checkvalido = false;
        vm.questionClicked = false;
        vm.respuesta = [];
        vm.errorArchivo = false;
        vm.respuestasUsuario = [];
        vm.categoria_colaboracion;
        vm.progreso_colaboracion = [];
        vm.dateRange = false;
        vm.today = new Date();
        vm.fecha_final = false;
        $scope.videosVistos = {};
        vm.completada = false;
        vm.completadas = 0;
        vm.pendientes = 0;
        vm.ultima_respuesta = 0;
        vm.user_id = null;
        vm.startDate = null;
        vm.EndDate = null;
        vm.colaboracionesCompletadas = [];
        vm.colaboracionesPendientes = [];
        vm.hoy = $filter('date')(vm.today, "yyyy/MM/dd");
        vm.procesando = false;


        vm.empty = function (val) {
            var empty = true;
            if (typeof val === "undefined" || typeof val === "null" || val == undefined || val == null)
                return empty;

            if (typeof val === 'string') {
                if (val.trim() === '')
                    return empty;
            }

            if (typeof val === 'number') {
                if (!val)
                    return empty;
            }

            if (typeof val === 'object') {

                if (val.length === undefined) {
                    var r = false;
					angular.forEach(val, function (value, key) {
						if (key === 'resp_validada' || key === 'textinvalid') return;
                        if (typeof value === 'string') {
                            if (value.trim() === '')
                                r = true;

                            if (value.trim() === '0')
                                r = true;
                        }
                        if (typeof value === 'number') {
                            if (value === 0)
                                r = true;
                        }
						if (value === undefined || value === null) {

                            r = true;
                        }
                    });

                    if (!Object.keys(val).length)
                        r = true;



                    if (r)
                        return empty;
                } else {
                    if (val.length) {
                        if (!val[0])
                            return !val[0];
                        if (val[0].length !== undefined)
                            return !val[0].length;
                    }
                }

                if (val.length === 0)
                    return empty;
            }
            return false;

        }


        vm.seleccionarTarea = function (key) {
            // No permitir ir a una tarea ya validada si la colaboración está descartada (133)
            if (vm.colaboracion_estado == 133 && vm.respuesta[key] && vm.respuesta[key].resp_validada == '1') {
                return;
            }

            // Permitir navegar si es la primera tarea, ó si la anterior tiene respuesta ó tiene ficheros (para tipología 91)
            if (!key || !vm.empty(vm.respuesta[key - 1]) || !vm.empty(vm.ficheros[key - 1])) {
                vm.pagina = key;
                if (typeof swiperheader !== 'undefined') swiperheader.slideTo(vm.pagina)
            }
        }
        var params = new URLSearchParams(window.location.search);
        vm.hash = params.get('hash');
        vm.Tareas = function () {

            ColaboracionService.getRespuestas(vm.id, vm.hash).then(function (resp) {
                ColaboracionService.getTareas(vm).then(function (data) {
                    // console.log("hash", vm.hash);
                    var tasksToProcess = data.tareas;
                    vm.colaboraciones = data.colaboraciones;
                    
                    // Manejo robusto de mymetype (puede venir como objeto o array)
                    vm.mymetype = angular.isArray(data.mymetype) ? data.mymetype[0] : data.mymetype;
                    
                    if (vm.mymetype && vm.mymetype.extension) {
                        vm.extensions = vm.mymetype.extension.replaceAll(",", ', ');
                    } else {
                        vm.extensions = "";
                    }

                    vm.divisionTareas = (100 / tasksToProcess.length).toFixed(2);
                    vm.divisionTareas = parseFloat(vm.divisionTareas);

                    angular.forEach(tasksToProcess, function (value, key) {
                        vm.ficheros[key] = [];
                        vm.respuesta[key] = {};
                        
                        if (value.format_file) {
                            var formats = angular.isArray(value.format_file) ? value.format_file : [value.format_file];
                            if (formats.length > 0) {
                                value.mime_ids = formats.map(function (f) { return f ? f.id : ''; }).filter(Boolean).join(',');
                            }
                        }
						
                        if (value.tipologia == 88 && value.opciones.tipo_pregunta == 'selector')
                            vm.respuesta[key] = { answerselector: "" };

                        if (value.tipologia == 89) {
                            vm.respuesta[key] = [];
                            angular.forEach(value.youtube_url.filas, function (vvvalue, vvkey) {
								vm.respuesta[key].push(false)
								
								if (vvvalue.enlace) {
									vvvalue.safeUrl = $sce.trustAsResourceUrl(
										'https://www.youtube.com/embed/' + vvvalue.enlace + '?enablejsapi=1'
									);
								}
                            });
                        }

                        vm.respuestas.push({ "tareas": value, "respuesta": {} });

                        if (resp.status == 200) {
                            if (resp.respuestas && resp.respuestas.stages && resp.respuestas.stages[key]) {
                                var res_actual = resp.respuestas.stages[key].respuesta;
                                
								// Si es tarea de vídeos o de descarga de arhcivos, damos por hecho que si tiene respuesta está validada 
                                // Si es tarea de vídeos o de descarga de archivos, solo se valida si se han completado todos (vídeos vistos o archivos descargados)
								if ((value.tipologia == 102 || value.tipologia == 89) && !vm.empty(res_actual) && res_actual.resp_validada !== '0') {
									var totalItems = 0;
									var itemsCompletados = 0;

									if (value.tipologia == 102) {
										totalItems = Array.isArray(value.archivos) ? value.archivos.length : (value.archivos ? Object.keys(value.archivos).length : 0);
										angular.forEach(res_actual, function (v, k) { if (k !== 'resp_validada' && k !== 'textinvalid' && v && v.download) itemsCompletados++; });
									} else if (value.tipologia == 89) {
										totalItems = value.youtube_url && value.youtube_url.filas ? value.youtube_url.filas.length : 0;
										angular.forEach(res_actual, function (v, k) { if (k !== 'resp_validada' && k !== 'textinvalid' && v) itemsCompletados++; });
									}

									if (itemsCompletados >= totalItems) {
										res_actual.resp_validada = '1';
									}
								}

                                // Si tiene respuesta Y NO está rechazada, o si está explícitamente validada como correcta
                                if ((!vm.empty(res_actual) && res_actual.resp_validada !== '0') || res_actual.resp_validada == '1') {
                                    vm.respuesta[key] = res_actual;
                                    
                                    // Solo avanzamos si no es la última tarea
                                    if (vm.pagina == key && vm.pagina < tasksToProcess.length - 1) {
                                        vm.pagina++;
                                    }
                                    
                                    if (vm.ultima_respuesta <= key) {
                                        vm.ultima_respuesta = key + 1;
                                    }
                                } else if (res_actual && res_actual.resp_validada == '0') {
                                    // Si está rechazada, guardamos la respuesta pero NO avanzamos la página
                                    vm.respuesta[key] = res_actual;
                                    // El límite de navegación debe llegar hasta aquí para que pueda editarla
                                    if (vm.ultima_respuesta <= key) {
                                        vm.ultima_respuesta = key;
                                    }
                                }
                            }
                        }
                    });

                    vm.tareas = tasksToProcess;

                    $timeout(function() {
                       if (typeof swiperheader !== 'undefined') swiperheader.slideTo(vm.pagina);
                    }, 200);

                })
            })

        }


        vm.completada = false;
        vm.next = function () {
            if (vm.procesando) return;
            vm.procesando = true;

            // vm.botonchecked = false;
            if (typeof swiperheader !== 'undefined') swiperheader.slideNext();



            // Si la respuesta actual estaba rechazada, la "limpiamos" para que vuelva a estar pendiente
            if (vm.respuesta[vm.pagina] && vm.respuesta[vm.pagina].resp_validada == '0') {
                delete vm.respuesta[vm.pagina].resp_validada;
            }

            $timeout(function () {
                vm.pagina = vm.pagina + 1;

                // Saltar tareas solo si están validadas como correctas (evitar saltar rechazadas)
                while (vm.tareas[vm.pagina] && vm.respuesta[vm.pagina] && vm.respuesta[vm.pagina].resp_validada == '1') {
                    vm.pagina++;
                }

                if (vm.pagina > vm.ultima_respuesta)
                    vm.ultima_respuesta++;

                if (vm.pagina == 0) {

                } else if (vm.pagina == 1) {
                    vm.result = vm.divisionTareas + vm.divisionTareas;
                } else if (vm.pagina > 1) {
                    vm.result = vm.result + vm.divisionTareas;
                }

                angular.forEach(vm.respuestas, function (value, key) {
                    vm.respuestas[key].respuesta = vm.respuesta[key];
                    if (!vm.empty(vm.ficheros[key]))
                        vm.respuestas[key].respuesta = vm.ficheros[key];
                });

                if (vm.pagina == vm.tareas.length) {
                    var myModal = new bootstrap.Modal(document.getElementById('tareaCompletada'), {
                        keyboard: false
                    })
                    myModal.show()
                    vm.completada = true;
                }

                ColaboracionService.guardartareas(vm.id, vm.respuestas, vm.completada, vm.hash).then(function (data) {
                    vm.completada = false;
                    vm.procesando = false;
                    // console.log(vm.completada);
                }).catch(function() {
                    vm.completada = false;
                    vm.procesando = false;
                });
            }, 100);

        }

        vm.subirFichero = function (data) {

            if (angular.isArray(data.data.name)) {
                angular.forEach(data.data.name, function (value, key) {
                    if (data.data.code == 200)
                        vm.ficheros[vm.pagina].push({ "code": 200, "file_id": data.data.file_id[key], "name": value })
                    else
                        vm.ficheros[vm.pagina].push({ "code": 304, "file_id": "", "name": value })
                })
            } else
                vm.ficheros[vm.pagina].push(data.data);

            vm.fichero = data.data;
            vm.archivosubido = true;
            vm.fichero.errorfile = data.data.errorfile;
            vm.fileError = data.data.fileError;

            // console.log(vm.ficheros[vm.pagina]);

        }

        vm.archivosubido = false;

        vm.errorFichero = function () {
            var b = false;
            angular.forEach(vm.ficheros[vm.pagina], function (value, key) {
                //vm.fichero.errorfile = value.errorfile;
                if (value.errorfile) {
                    // vm.errorArchivo = true;
                    b = true;
                }

            });
            return b;
        }

        vm.borrarFichero = function (index) {

            if (index > -1) {
                vm.ficheros[vm.pagina].splice(index, 1);
                // console.log(vm.ficheros[vm.pagina]);
                vm.archivosubido = false;
                vm.showerrors = false;
            }
        }

        vm.checkingfiles = function (max_limit, min_limit, fileslength) {
            var c = false;

            if ((max_limit < fileslength || min_limit > fileslength) && max_limit != 0) {
                // console.log("archivos no estan entre los limites ");

                c = true;

            } else {
                c = false;
                // console.log("correcto, esta entre los limites ");
            }

            return c;
        }

        vm.Checked = function (key) {
            var contador = 0;

            angular.forEach(vm.respuesta[key], function (value, index) {
                if (value && Number.isInteger(parseInt(index))) {
                    contador++;
                }
            });

            if (contador >= 1) {
                vm.botonchecked = true;

            } else {
                vm.botonchecked = false;

            }

            return vm.botonchecked;
        }

        vm.seenvideo = function (key) {
            var b = true;

            angular.forEach(vm.respuesta[key], function (value, key) {
                if (!value) {
                    b = false;
                }
            });

            return b;
        }

        vm.validCheck = function () {
            var b = false;

            angular.forEach(vm.answermultiple, function (value, key) {

                if (value) {
                    b = true;
                    vm.checkvalido = true;

                }
            });
            return b;
        }

        vm.filesaved = function (key) {
            var tarea = vm.tareas[key];
            if (tarea && tarea.tipologia == 102 && tarea.archivos) {
                var total = Array.isArray(tarea.archivos) ? tarea.archivos.length : Object.keys(tarea.archivos).length;
                var descargados = 0;
                angular.forEach(vm.respuesta[key], function (value, k) {
                    if (k !== 'resp_validada' && k !== 'textinvalid' && value && value.download) {
                        descargados++;
                    }
                });
                return descargados >= total;
            }

            var b = false;
            angular.forEach(vm.respuesta[key], function (value, k) {
                if (value && k !== 'resp_validada' && k !== 'textinvalid')
                    b = true;
            });

            return b;
        }

        vm.download = function (files) {
            //    vm.filesaved = true;
        }


        var contratoModal
        vm.modalContrato = function (contrato) {

            if (jQuery("#modalCheck").length) {
                contratoModal = new bootstrap.Modal(document.getElementById('modalCheck'), {
                    keyboard: false
                })
                contratoModal.show()
            }


        }

        vm.modalAbonos = function () {
            var modalAbon = new bootstrap.Modal(document.getElementById('modalAbonos'), {
                keyboard: false
            })
            modalAbon.show()
        }

        vm.aceptoFirmaContrato = function (colaboracion_id, tarea_usuario_id,hash) {

            ColaboracionService.getFirmaContrato(colaboracion_id, tarea_usuario_id,hash).then(function (data) {
                vm.contrato = data.contrato;

                contratoModal.hide();
            })
        }


        vm.modalContrato();
    }

})();